import { Box, OutlinedInput, Stack } from "@mui/material";
import React, { useState } from "react";
import classes from "../../DatosCliente.module.css";
import Theme from "../../../../../constants/Theme";

function NumeroCiudadEstado({ formik }) {
  const [numeroExtHelperText, setNumeroExtHelperText] = useState(
    "Ingresa tu número exterior"
  );
  const [numeroIntHelperText, setNumeroIntHelperText] = useState(
    "Ingresa tu número interior"
  );
  const [ciudadHelperText, setCiudadHelperText] =
    useState("Verifica tu ciudad");

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={3}
      style={{ marginBottom: 10 }}
    >
      <Box style={{ flex: 1 }}>
        <OutlinedInput
          placeholder="Número exterior"
          onFocus={() => setNumeroExtHelperText("Debe ser numérico o 'SN'")}
          onChange={formik.handleChange("numeroExterior")}
          value={formik.values.numeroExterior}
          error={formik.errors.numeroExterior && formik.touched.numeroExterior}
          type="text"
          style={{ width: "100%" }}
          autoComplete="new-password"
        />
        <p
          style={
            formik.errors.numeroExterior && formik.touched.numeroExterior
              ? { color: Theme.COLORS.ERROR }
              : {}
          }
          className="helperText"
        >
          {formik.errors.numeroExterior && formik.touched.numeroExterior
            ? formik.errors.numeroExterior
            : numeroExtHelperText}
        </p>
      </Box>

      <Box style={{ flex: 1 }}>
        <OutlinedInput
          placeholder="Número interior"
          onFocus={() => setNumeroIntHelperText("Verifica tu número interior")}
          onChange={formik.handleChange("numeroInterior")}
          value={formik.values.numeroInterior}
          error={formik.errors.numeroInterior && formik.touched.numeroInterior}
          type="text"
          style={{ width: "100%" }}
          autoComplete="new-password"
        />
        <p
          style={
            formik.errors.numeroInterior && formik.touched.numeroInterior
              ? { color: Theme.COLORS.ERROR }
              : {}
          }
          className="helperText"
        >
          {formik.errors.numeroInterior && formik.touched.numeroInterior
            ? formik.errors.numeroInterior
            : numeroIntHelperText}
        </p>
      </Box>
      <Box style={{ flex: "1" }}>
        <OutlinedInput
          placeholder="Ciudad"
          className={classes.inputDisabled}
          onFocus={() => setCiudadHelperText("Verifica tu ciudad")}
          onChange={formik.handleChange("ciudad")}
          value={formik.values.ciudad}
          error={formik.errors.ciudad && formik.touched.ciudad}
          type="text"
          style={{ width: "100%" }}
          autoComplete="new-password"
          disabled
        />
        <p
          style={
            formik.errors.ciudad && formik.touched.ciudad
              ? { color: Theme.COLORS.ERROR }
              : {}
          }
          className="helperText"
        >
          {formik.errors.ciudad && formik.touched.ciudad
            ? formik.errors.ciudad
            : ciudadHelperText}
        </p>
      </Box>
      <Box style={{ flex: "1" }}>
        <OutlinedInput
          placeholder="Estado"
          className={classes.inputDisabled}
          value={formik.values.estado}
          error={formik.errors.estado && formik.touched.estado}
          type="text"
          style={{ width: "100%", color: "#212121 !important" }}
          autoComplete="new-password"
          disabled
        />
        <p
          style={
            formik.errors.estado && formik.touched.estado
              ? { color: Theme.COLORS.ERROR }
              : {}
          }
          className="helperText"
        >
          {formik.errors.estado && formik.touched.estado
            ? formik.errors.estado
            : "Verifica tu estado"}
        </p>
      </Box>
    </Stack>
  );
}

export default NumeroCiudadEstado;
